import { render } from "./Navabr-saas.vue?vue&type=template&id=2050fbf7&scoped=true"
import script from "./Navabr-saas.vue?vue&type=script&lang=js"
export * from "./Navabr-saas.vue?vue&type=script&lang=js"

import "./Navabr-saas.vue?vue&type=style&index=0&id=2050fbf7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2050fbf7"]])

export default __exports__